// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"50ba2561","292":"8f01ee2f","484":"e045e2e4","540":"796bd6ac","644":"ea215e42","664":"d6f47e94","732":"dbe9bfb6","788":"18cc5edc","824":"b6d31cb3","872":"d6fe509e"}[chunkId] + ".chunk.js";
};